import "antd/es/select/style";
import _Select from "antd/es/select";
import withFieldWrap from '../../utils/withFieldWrap';
export default withFieldWrap(_Select);